export const MuiListNativeStyledStyle = {
  listItem: {
    display: "list-item",
  },
  list: {
    listStyleType: "disc",
    paddingInlineStart: "40px",
  },
};
